import { Button } from "@/components/ui/button";

import { CloseIcon } from "./icons";

interface CopyNotificationProps {
  onClose(): void;
}

export default function CopyNotification({ onClose }: CopyNotificationProps) {
  return (
    <div className="flex h-12 w-97 max-w-9/10 items-center rounded-[30px] bg-white px-[11px] shadow-9-6-4 shadow-black/10">
      <p className="grow-1 text-center text-16 text-eerie-black">
        Link copied to the clipboard
      </p>
      <Button
        aria-label="Close"
        className="size-[35px] shrink-0 rounded-full bg-mulberry/80"
        onClick={onClose}
      >
        <CloseIcon />
      </Button>
    </div>
  );
}
